import { DeviceModel } from '@/features/devices/types/types'
import { DeviceState } from '@/shared/components/DeviceState/DeviceState'
import { Skeleton } from '@/shared/components/shadcn'
import { formatDate } from '@/shared/lib/date'

type Props = {
  device: DeviceModel
  isLoading: boolean
}

export const DeviceBanner = ({ device, isLoading }: Props) => {
  const columnClasses =
    'flex flex-col gap-2 flex-1 border-b md:border-b-0 border-b-card-border dark:border-b-card-border-dark md:border-r last:border-0 md:border-r-card-border md:dark:border-r-card-border-dark pb-4 md:pb-0 last:pb-0 last:md:pl-6'
  const labelClasses = 'text-sm text-text-secondary'
  const dataClasses = 'font-klein font-medium text-sm md:text-base'

  return (
    <div className="flex md:flex-row flex-col gap-[10px] md:gap-0 bg-light-purple dark:bg-dark-purple md:p-6 px-[20px] py-6 rounded-2xl">
      <div className={`${columnClasses}`}>
        <span className={`${labelClasses}`}>Состояние</span>
        {isLoading ? (
          <Skeleton className="w-40 h-4" />
        ) : (
          <DeviceState
            direction="row"
            battery={device.battery}
            network={device.network}
            status={device.status}
          />
        )}
      </div>
      <div className={`${columnClasses}`}>
        <span className={`${labelClasses}`}>Последняя активность</span>
        {isLoading ? (
          <Skeleton className="w-40 h-4" />
        ) : (
          <span className={`${dataClasses}`}>
            {!device.lastPingedAt || device.lastPingedAt === 'Нет данных'
              ? 'Нет данных'
              : formatDate(device.lastPingedAt, 'long', {})}
          </span>
        )}
      </div>
    </div>
  )
}
